import getAttributes from './getAttributes'
import setAttributes from './setAttributes'

export default (attributes) => (el) => {
  const saved = getAttributes(Object.keys(attributes))(el)
  setAttributes(attributes)(el)

  return () => setAttributes(saved)(el)
}
